import React, { useId } from "react";
import { Form, Select } from "antd";
import Icons from "components/icons";
import { Localize } from "components/service";
import DocumentConst from "../../document-const";

const EditableDocumentZoneSelect = ({ form, disabled = false, initialPlacement = null }) => {
  const watchedPlacement = Form.useWatch("placement", form);
  const selectedPlacement = watchedPlacement === undefined ? initialPlacement ?? "" : watchedPlacement;
  const initialUnknownPlacement = initialPlacement && !DocumentConst.zones.some((zone) => zone.placement === initialPlacement)
    ? initialPlacement
    : null;
  const selectedZone = DocumentConst.zones.find((zone) => zone.placement === selectedPlacement);
  const invalidZoneMessage = Localize({ children: "APP_SETTINGS.Invalid_Zone" }).props.children;
  const placeholder = Localize({ children: "APP_SETTINGS.Placeholder_Zone" }).props.children;

  return (
    <Form.Item
      name="placement"
      className="document-zone-field"
      label={<Localize>APP_SETTINGS.Label_Zone</Localize>}
      getValueProps={(value) => ({ value: value || undefined })}
      extra={selectedZone?.descriptionKey ? <Localize>{selectedZone.descriptionKey}</Localize> : undefined}
      rules={[{ required: true, whitespace: true, message: <Localize>APP_SETTINGS.Required_Zone</Localize> }, {
        validator(_, value) {
          if (value == null || value === "" || value === initialUnknownPlacement || DocumentConst.zones.some((zone) => zone.placement === value)) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(invalidZoneMessage));
        },
      }]}
    >
      <Select
        showSearch
        placeholder={placeholder}
        suffixIcon={<Icons.Arrow />}
        className="select-serch-input"
        popupClassName="select-serch-dropdown"
        optionFilterProp="value"
        disabled={disabled}
      >
        {DocumentConst.zones.map((zone) => (
          <Select.Option key={zone.placement} value={zone.placement}>
            <Localize>{zone.labelKey}</Localize>
          </Select.Option>
        ))}
        {initialUnknownPlacement && (
          <Select.Option key={initialUnknownPlacement} value={initialUnknownPlacement}>
            <Localize placement={initialUnknownPlacement}>APP_SETTINGS.Zone_Unknown</Localize>
          </Select.Option>
        )}
      </Select>
    </Form.Item>
  );
};

const DocumentZonePreview = ({ initialPlacement = null }) => {
  const previewId = useId();
  const helperId = `${previewId}-help`;
  const value = initialPlacement ?? "";
  const knownZone = DocumentConst.zones.find((zone) => zone.placement === value);
  const label = knownZone ? <Localize>{knownZone.labelKey}</Localize>
    : value ? <Localize placement={value}>APP_SETTINGS.Zone_Unknown</Localize>
      : <Localize>APP_SETTINGS.Zone_Unassigned</Localize>;
  return (
    <Form.Item
      className="document-zone-field document-zone-preview"
      label={<Localize>APP_SETTINGS.Label_Zone</Localize>}
      htmlFor={previewId}
      extra={<span id={helperId}><Localize>APP_SETTINGS.Placement_Unavailable</Localize></span>}
    >
      <Select
        id={previewId}
        aria-describedby={helperId}
        disabled
        value={value}
        suffixIcon={<Icons.Arrow />}
        className="select-serch-input"
        popupClassName="select-serch-dropdown"
      >
        <Select.Option value={value}>{label}</Select.Option>
      </Select>
    </Form.Item>
  );
};

const DocumentZoneSelect = ({ preview = false, ...props }) => preview
  ? <DocumentZonePreview initialPlacement={props.initialPlacement} /> : <EditableDocumentZoneSelect {...props} />;

export default DocumentZoneSelect;
